import LabeledRadioInput from "components/labeledInput/LabeledRadioInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledRadioInput);
